module.exports = __webpack_public_path__ + "static/media/headlights-and-taillights.cb6989d6.svg";